import React from "react";
import { Box, FormControlLabel, Checkbox } from "@mui/material";

type LayerCheckboxesProps = {
  activeLayers: ActiveLayers;
  setActiveLayers: (activeLayers: ActiveLayers) => void;
};

const layerItems = [
  { name: "assetsLayerIsActive", label: "Assets" },
  { name: "concessions", label: "Concessions" },
  { name: "detectedMines", label: "Detected Mines" },
  { name: "deforestations", label: "Deforestation" },
  { name: "indigenous", label: "Indigenous Lands" },
];

export const LayerCheckboxes: React.FC<LayerCheckboxesProps> = ({ activeLayers, setActiveLayers }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setActiveLayers({
      ...activeLayers,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <Box display="flex">
      {layerItems.map((item) => (
        <Box key={item.name} m={1}>
          <FormControlLabel
            label={item.label}
            name={item.name}
            control={
              <Checkbox
                checked={activeLayers[item.name as keyof ActiveLayers]}
                onChange={(event) => handleChange(event)}
                color="primary"
              />
            }
          />
        </Box>
      ))}
    </Box>
  );
};
